import React from "react";
import styled from "styled-components";
import { Card, Intent, Tag } from "@blueprintjs/core";
import { Box } from "ui-components";

type Props = {
  relevancyScore: string;
};
const RelevancyScore = (props: Props) => {
  return (
    <div className="relevancy-score">
      <span className={`score ${getScoreColor(props.relevancyScore)}`}>
        {props.relevancyScore}
      </span>
    </div>
  );
};

export default RelevancyScore;

// Helper function to get the color based on score
const getScoreColor = (score: string): string => {
  const numericScore = parseInt(score); // Convert the score string to a number
  if (numericScore >= 80) return "high-score";
  if (numericScore >= 60) return "medium-score";
  return "low-score";
};
